module.exports = __webpack_public_path__ + "static/media/19ESCAP39.12dae2f4.jpg";